import {NetworkService} from "./NetworkService";
import {sessionStore} from "../store/sessionStore";
import StoreService from "./StoreService";


export class LoginServices {
  static async login(email, password) {
    try {
      const loginResponse = await NetworkService.request({
        url: "users/login",
        method: "POST",
        data: { email, password },
        ignoreUnauthorizedError: true,
      });
      sessionStore.userId = loginResponse.id;
      sessionStore.token = loginResponse.token;
      sessionStore.isTokenExpired = false;
      sessionStore.isLoggedIn = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  static async logout() {
    await NetworkService.request({
      url: "users/logout",
      method: "POST",
    });
    StoreService.clearStore();
    window.location.href = "/login";
  }

  static expireSession() {
    StoreService.clearStore();
    localStorage.setItem("session_expired_message", "Sua sessão expirou. Faça login novamente.");
    window.location.href = "/login";
  }
  static verifySession() {
    return sessionStore.isLoggedIn;
  }
  static currentUser() {
    return NetworkService.request({
      url: "users/current",
      method: "GET",
    });
  }
}

